module.exports = __webpack_public_path__ + "static/img/MAG.a28e7d6d.png";